import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	Typography,
} from "@mui/material";
import { debounce } from "lodash";
import { useMemo } from "react";
import { getAllPopups } from "../../apis/GrapeList";
import { FilterAutocomplete } from "../Form/FilterAutocomplete";
import { useGrapeList } from "./context/GrapeListProvider";

export const AddGrapeListPopupDialog = () => {
	const { popupOpen, handlePopupClose, setSelectedPopup } = useGrapeList();

	const handleChange = useMemo(
		() =>
			debounce((name, item) => {
				setSelectedPopup(item || null);
			}, 500),
		[setSelectedPopup],
	);

	return (
		<Dialog
			open={popupOpen}
			keepMounted
			onClose={handlePopupClose}
			PaperProps={{
				sx: {
					width: 900,
					p: 4,
				},
			}}
			maxWidth="md"
		>
			<DialogTitle>Add Popup</DialogTitle>

			<DialogContent>
				<Grid container spacing={4} py={2} alignItems="center">
					<Grid item xs={12}>
						<Box
							display="flex"
							justifyContent="space-between"
							alignItems="center"
							width="100%"
						>
							<Typography variant="h6">Popup</Typography>

							<Box width={{ xs: "100%", sm: 300 }}>
								<FilterAutocomplete
									fetchOptions={getAllPopups}
									label="Popup"
									handleChange={handleChange}
									name="popup"
								/>
							</Box>
						</Box>
					</Grid>
				</Grid>
			</DialogContent>

			<DialogActions>
				<Button variant="contained" onClick={handlePopupClose}>
					Add Popup
				</Button>
			</DialogActions>
		</Dialog>
	);
};
